export default __webpack_public_path__ + "static/media/log-out-icon.6bb201b5.svg";